<div>
    <div *ngIf="SiteData && ProductionData" class="card">
        <div class="card-body">
            <h4 class="card-title">{{this.title}}</h4>
            <p class="red">All bold fields are required</p>
            <div class="table-responsive">
                <table style="width : 100%">
                    <tr>
                        <td class="col-md-1">Site Data</td>
                        <td style="width: 1%;">:</td>
                        <td class="col-md-3">Gases and Volume Data</td>
                        <td class="col-md-1">Name</td>
                        <td style="width: 1%;">:</td>
                        <td class="col-md-3">{{SiteData.siteName}}</td>
                    </tr>
                    <tr>
                        <td class="col-md-1">Inserted By :</td>
                        <td style="width: 1%;">:</td>
                        <td class="col-md-3">{{SiteData.insertedBy}} <span *ngIf="SiteData.insertedDate"> on
                                {{SiteData.insertedDate | date}}</span></td>
                        <td class="col-md-1">Modified By</td>
                        <td style="width: 1%;">:</td>
                        <td class="col-md-3">{{SiteData.modifiedBy}}<span *ngIf="SiteData.modifiedDate"> on
                                {{SiteData.modifiedDate | date}}</span></td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
    <plant-ownership [buttonTrigger]="popupVisible" [siteId]="siteId" [companySites]="CompanySiteData"
        [siteType]="siteType" (setPopupVisibility)="setPopupVisibility($event)"
        (setCompanySites)="setCompanySites($event)"
        (createCompanySiteForNewSite)="createCompanySiteForNewSite($event)"></plant-ownership>
    <dx-load-panel #dxLoadPanel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoadPanelVisible" [showPane]="true"
        [shading]="false" [closeOnOutsideClick]="false">
    </dx-load-panel>
    <app-googlemaps [buttonTrigger]="mapsPopupVisible" [isReadOnly]="false" [Coordinates]="Coordinates"
        (savecordinates)="savecordinates($event)" (setmapsPopupVisibility)="setmapsPopupVisibility($event)">
    </app-googlemaps>
    <okaycanceldialog [buttonTrigger]="okayCancelDialogVisible" [message]="message" [eventkey]="eventkey"
        (ProcessresultFromdialog)="ProcessresultFromdialog($event)"></okaycanceldialog>
    <app-editvolume [buttonTrigger]="volumePopupVisible" [siteId]="siteId" [ProductionData]="ProductionData"
        (setGasFlagForGeoCalcuation)="setGasFlagForGeoCalcuation($event)"
        (setVolumePopupVisibility)="setVolumePopupVisibility($event)"
        (setProdVolHistoryData)="setProdVolHistoryData($event)" (setProductionData)="setProductionData($event)" ></app-editvolume>
    <form #siteForm="ngForm" (ngSubmit)="OnSaveClicked()" autocomplete="off" showValidationSummary="true">
        <dx-validation-group>
            <div *ngIf="SiteData && ProductionData" style="margin-top: 15px;" class="card">
                <div class="card-body">
                    <h5 class="card-title">Plant/Site Location information</h5>
                    <div class="table-responsive">
                        <table class="col-md-12">
                            <tr class="maxheight">
                                <td><span class="bold">Plant Type</span><span class="red">*</span></td>
                                <td>
                                    <div>
                                        <div class="dx-field">
                                            <div class="dx-field-value">
                                                <dx-radio-group [items]="modes" valueExpr="value" displayExpr="text"
                                                    (onValueChanged)="onModeValueChanged($event)"
                                                    [(value)]="SiteData.plantBusiness" layout="horizontal">
                                                    <dx-validator>
                                                        <dxi-validation-rule type="required"
                                                            message="Plant Type is required">
                                                        </dxi-validation-rule>
                                                        <!-- <dxi-validation-rule reevaluate="true" type="custom"
                                                        [validationCallback]="validatePlantType"
                                                        message="Put a check next to each gas produced at this site.  At least one gas MUST be checked.">
                                                    </dxi-validation-rule> -->
                                                    </dx-validator>
                                                </dx-radio-group>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr style="height: auto;">
                                <td>
                                    <div class="flexdir">
                                        <div>
                                            <span class="bold">Company/Owner</span><span class="red">*</span>
                                        </div>
                                        <div>
                                            <dx-button class="ap-blue-btn" text="Edit Ownership"
                                                (onClick)="EditOwnershipClicked()">
                                            </dx-button>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div class="dx-field">
                                        <div class="dx-field-value">
                                            <div *ngIf="CompanySiteData && CompanySiteData.length > 0"
                                                class="table-responsive">
                                                <table class="col-md-12">
                                                    <tr class="aligntextcenter tblCompanyOwnerHeader">
                                                        <td class="borderall">Company^</td>
                                                        <td class="borderall">%OwnerShip</td>
                                                    </tr>
                                                    <tr *ngFor="let owner of CompanySiteData">
                                                        <td class="borderall">{{owner.companyName}}</td>
                                                        <td class="borderall aligntextcenter">
                                                            {{owner.companyOwnerSharePercent}}
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                            <div *ngIf="CompanySiteData && CompanySiteData.length == 0">
                                                Please add company ownership
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr class="maxheight">
                                <td [class.bold]="SiteData.plantBusiness != 'T'">Site Name<span
                                        *ngIf="SiteData.plantBusiness != 'T'" class="red">*</span></td>
                                <td>
                                    <div class="dx-field">
                                        <div class="dx-field-value">
                                            <dx-text-box [(value)]="SiteData.siteName">
                                                <dx-validator>
                                                    <dxi-validation-rule *ngIf="SiteData.plantBusiness != 'T'"
                                                        type="required" message="Site Name is required">
                                                    </dxi-validation-rule>
                                                </dx-validator>
                                            </dx-text-box>

                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr class="maxheight">
                                <td [class.bold]="SiteData.plantBusiness == 'T'">Legal Entity/Local Company Name<span
                                        *ngIf="SiteData.plantBusiness == 'T'" class="red">*</span></td>
                                <td>
                                    <div class="dx-field">
                                        <div class="dx-field-value">
                                            <dx-text-box [(value)]="SiteData.localCompanyName">
                                                <dx-validator>
                                                    <dxi-validation-rule *ngIf="SiteData.plantBusiness == 'T'"
                                                        type="required" message="Legal Entity is required">
                                                    </dxi-validation-rule>
                                                </dx-validator>
                                            </dx-text-box>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr class="maxheight">
                                <td class="bold">Country<span class="red">*</span></td>
                                <td>
                                    <div class="dx-field">
                                        <div class="dx-field-value">
                                            <dx-select-box #selectBox [dataSource]="countiesDataSource"
                                                [acceptCustomValue]="true" displayExpr="countryName"
                                                valueExpr="countryId" [(value)]="SiteData.countryId"
                                                [searchEnabled]="true" (onValueChanged)="OnCountrySelected()"
                                                (onCustomItemCreating)="addCustomItem($event,countiesDataSource,'countryName')">
                                                <dx-validator>
                                                    <dxi-validation-rule type="required" message="Country is required">
                                                    </dxi-validation-rule>
                                                </dx-validator>
                                            </dx-select-box>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr class="maxheight">
                                <td class="bold">State/Province<span class="red">*</span></td>
                                <td>
                                    <div class="dx-field">
                                        <div class="dx-field-value">
                                            <dx-select-box #selectBox [dataSource]="provinceDataSource"
                                                [acceptCustomValue]="true" displayExpr="province" valueExpr="statProvId"
                                                [(value)]="SiteData.statProvId" [searchEnabled]="true"
                                                (onValueChanged)="OnProvienceSelected()"
                                                (onCustomItemCreating)="addCustomItem($event,provienceDataSource,'province')">
                                                <dx-validator>
                                                    <dxi-validation-rule type="required"
                                                        message="State/Province is required">
                                                    </dxi-validation-rule>
                                                </dx-validator>
                                            </dx-select-box>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr class="maxheight">
                                <td class="bold">City<span class="red">*</span></td>
                                <td>
                                    <div class="dx-field">
                                        <div class="dx-field-value">
                                            <dx-select-box #selectBox [dataSource]="citiesDataSource"
                                                [acceptCustomValue]="true" displayExpr="city" valueExpr="city"
                                                [(value)]="SiteData.city" [searchEnabled]="true"
                                                (onCustomItemCreating)="addCustomItem($event,citiesDataSource,'city')">
                                                <dx-validator>
                                                    <dxi-validation-rule type="required" message="City is required">
                                                    </dxi-validation-rule>
                                                </dx-validator>
                                            </dx-select-box>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr class="maxheight">
                                <td>Street Address (English)</td>
                                <td>
                                    <div class="dx-field">
                                        <div class="dx-field-value">
                                            <dx-text-box [(value)]="SiteData.address"></dx-text-box>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr class="maxheight">
                                <td>Postal Code (recommended)</td>
                                <td>
                                    <div class="dx-field">
                                        <div class="dx-field-value">
                                            <dx-text-box [(value)]="SiteData.zipCode"></dx-text-box>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr *ngIf="SiteData.plantBusiness == 'M' || SiteData.plantBusiness == 'B'"
                                class="maxheight">
                                <td>Sub Region</td>
                                <td>
                                    <div class="dx-field">
                                        <div class="dx-field-value">
                                            <dx-select-box #selectBox [dataSource]="subRegionDataSource"
                                                [acceptCustomValue]="false" displayExpr="subRegion1"
                                                valueExpr="subRegion1" [(value)]="SiteData.subRegion"
                                                [searchEnabled]="true">
                                            </dx-select-box>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr class="maxheight">
                                <td>
                                    <div class="flexdir">
                                        <div>
                                            <span class="bold">Coordinates<span class="red">*</span></span>
                                        </div>
                                        <div>
                                            <dx-button  class="ap-blue-btn" (onClick)="FindCoordinates()"
                                                text="Find Lat/Lan/Alt"></dx-button>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div class="dx-field">
                                        <div class="dx-field-value">
                                            <table>
                                                <tr>
                                                    <td class="col-md-1 zeroPadding bold">Latitude<span
                                                            class="red">*</span>
                                                    </td>
                                                    <td class="col-md-3">
                                                        <div>
                                                            <dx-text-box [(value)]="SiteData.latitude"
                                                                (onValueChanged)="latitudeChanged()">
                                                                <dx-validator>
                                                                    <dxi-validation-rule type="required"
                                                                        message="Latitude is required">
                                                                    </dxi-validation-rule>
                                                                    <dxi-validation-rule type="range" [max]="90"
                                                                        [min]="-90"
                                                                        message="Latitude must be between -90 and +90">
                                                                    </dxi-validation-rule>
                                                                </dx-validator>
                                                            </dx-text-box>
                                                        </div>
                                                    </td>
                                                    <td style="margin-left: 5px;" class="col-md-1 zeroPadding bold">
                                                        Longitude<span class="red">*</span>
                                                    </td>
                                                    <td class="col-md-3">
                                                        <div>
                                                            <dx-text-box [(value)]="SiteData.longitude">
                                                                <dx-validator>
                                                                    <dxi-validation-rule type="required"
                                                                        message="Longitude is required">
                                                                    </dxi-validation-rule>
                                                                    <dxi-validation-rule type="range" [max]="180"
                                                                        [min]="-180"
                                                                        message="Longitude must be between -180 and +180">
                                                                    </dxi-validation-rule>
                                                                </dx-validator>
                                                            </dx-text-box>
                                                        </div>
                                                    </td>
                                                    <td style="margin-left: 5px;" class="col-md-1 zeroPadding">Altitude
                                                        (Feet)</td>
                                                    <td class="col-md-3 rightpadding">
                                                        <div>
                                                            <dx-text-box class="tbaltitude" [disabled]="true"
                                                                [(value)]="SiteData.altitudeFeet">
                                                            </dx-text-box>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr *ngIf="!isPlantSite" class="textareaheight">
                                <td>Customer Comments</td>
                                <td>
                                    <div class="dx-field">
                                        <div class="dx-field-value">
                                            <dx-text-area [height]="50" [(value)]="SiteData.comment"></dx-text-area>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr *ngIf="isPlantSite" class="textareaheight">
                                <td>Plant Comments</td>
                                <td>
                                    <div class="dx-field">
                                        <div class="dx-field-value">
                                            <dx-text-area [height]="50"
                                                [(value)]="ProductionData.comment"></dx-text-area>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr *ngIf="SiteData.plantBusiness == 'M' || SiteData.plantBusiness == 'B'"
                                class="maxheight">
                                <td class="bold">Real/Temporary Plant<span class="red">*</span></td>
                                <td>
                                    <div class="dx-field">
                                        <div class="dx-field-value">
                                            <dx-select-box name="realTemporaryPlatOptions" id="realTemporaryPlatOptions"
                                                [items]="realTemporaryPlatOptions" displayExpr="value" valueExpr="value"
                                                [(value)]="ProductionData.plantStatus" (onValueChanged)="onRealTemporaryPlantOptionsChanged($event)">
                                                <dx-validator>
                                                    <dxi-validation-rule type="required"
                                                        message="Real/Temporary Plant is required">
                                                    </dxi-validation-rule>
                                                </dx-validator>
                                            </dx-select-box>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr *ngIf="SiteData.plantBusiness == 'T' || SiteData.plantBusiness == 'B'"
                                class="maxheight">
                                <td>Local Company Type</td>
                                <td>
                                    <div class="dx-field">
                                        <div class="dx-field-value">
                                            <dx-select-box #selectBox [dataSource]="localCompanyTypesDataSource"
                                                [acceptCustomValue]="false" displayExpr="localCompanyType"
                                                valueExpr="localCompanyType" [(value)]="SiteData.localCompanyType"
                                                [searchEnabled]="true">
                                            </dx-select-box>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr *ngIf="SiteData.plantBusiness == 'T' || SiteData.plantBusiness == 'B'"
                                class="maxheight">
                                <td>Industrial Zone(Province - City- Zone)</td>
                                <td>
                                    <div class="dx-field">
                                        <div class="dx-field-value">
                                            <dx-select-box #selectBox [dataSource]="industrialZonesDataSource"
                                                [acceptCustomValue]="false" displayExpr="industrialZoneName"
                                                valueExpr="industrialZoneID" [(value)]="SiteData.industrialZoneId"
                                                [searchEnabled]="true">
                                            </dx-select-box>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr *ngIf="SiteData.plantBusiness == 'T' || SiteData.plantBusiness == 'B'"
                                class="maxheight">
                                <td>Franchise</td>
                                <td>
                                    <div class="dx-field">
                                        <div class="dx-field-value">
                                            <dx-select-box #selectBox [dataSource]="franchiseDataSource"
                                                [acceptCustomValue]="false" displayExpr="franchiseName"
                                                valueExpr="franchiseId" [(value)]="SiteData.franchiseId"
                                                [searchEnabled]="true">
                                            </dx-select-box>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr *ngIf="SiteData.plantBusiness == 'T' || SiteData.plantBusiness == 'B'"
                                class="maxheight">
                                <td>PADD Name</td>
                                <td>
                                    <div class="dx-field">
                                        <div class="dx-field-value">
                                            <dx-select-box #selectBox [dataSource]="paddnameDataSource"
                                                [acceptCustomValue]="false" displayExpr="name" valueExpr="name"
                                                [(value)]="SiteData.paddname" [searchEnabled]="true">
                                            </dx-select-box>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr *ngIf="SiteData.plantBusiness == 'M' || SiteData.plantBusiness == 'B'"
                                style="margin-top: 5px;">
                                <td>
                                    <div class="flexdir">
                                        <div>
                                            <span>Products</span>
                                        </div>
                                        <div>
                                            <dx-button
                                            [disabled]="!(sharedSvc.UserRoles && (sharedSvc.UserRoles['isIGAdmin'] || sharedSvc.UserRoles['isTGEEAdmin']))"
                                            class="ap-blue-btn" text="Edit Volume" (onClick)="EditVolumeClicked()">
                                        </dx-button>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div class="dx-field ">
                                        <div class="dx-field-value">
                                            <div class="table-responsive tblborder">
                                                <table style="margin-left: 20px;" class="col-md-11">
                                                    <tr style="height: 50px;">
                                                        <td class="col-md-3 zeroPadding">
                                                            <div class="zeroPadding leftfloat">
                                                                <div class="dx-field ">
                                                                    <div class="flexdir">
                                                                        <dx-check-box [readOnly]="productsReadOnly"
                                                                            [(value)]="ProductionData.linflag"
                                                                            text="LB LIN (MTD)">
                                                                        </dx-check-box>
                                                                        <dx-check-box [readOnly]="productsReadOnly"
                                                                            class="topmargincb"
                                                                            [(value)]="ProductionData.loxflag"
                                                                            text="LB LOX (MTD)">
                                                                        </dx-check-box>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="zeroPadding leftfloat">
                                                                <div class="dx-field">
                                                                    <dx-text-box [readOnly]="productsReadOnly"
                                                                        [(value)]="ProductionData.capacity">
                                                                        <dx-validator>
                                                                            <dxi-validation-rule type="pattern"
                                                                                [pattern]="numberPattern"
                                                                                message="Only numbers are allowed">
                                                                            </dxi-validation-rule>
                                                                        </dx-validator>
                                                                    </dx-text-box>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="ml-3 leftfloat">
                                                                <div class="dx-field">
                                                                    <dx-check-box [readOnly]="productsReadOnly" class="topmargincb"
                                                                        [(value)]="ProductionData.larflag"
                                                                        text="LB LAR (MTD)">
                                                                    </dx-check-box>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="zeroPadding leftfloat">
                                                                <div class="dx-field">
                                                                    <dx-text-box [readOnly]="productsReadOnly"
                                                                        [(value)]="ProductionData.larTpd">
                                                                        <dx-validator>
                                                                            <dxi-validation-rule type="pattern"
                                                                                [pattern]="numberPattern"
                                                                                message="Only numbers are allowed">
                                                                            </dxi-validation-rule>
                                                                        </dx-validator>
                                                                    </dx-text-box>
                                                                </div>
                                                            </div>
                                                        </td>

                                                    </tr>
                                                    <tr class="maxheight">
                                                        <td>
                                                            <div class="zeroPadding leftfloat">
                                                                <div class="dx-field">
                                                                    <dx-check-box [readOnly]="productsReadOnly" class="topmargincb"
                                                                        [(value)]="ProductionData.lhyflag"
                                                                        text="LHy (MTD)">
                                                                    </dx-check-box>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="zeroPadding leftfloat">
                                                                <div class="dx-field">
                                                                    <dx-text-box [readOnly]="productsReadOnly"
                                                                        [(value)]="ProductionData.lhyvolumeTpd">
                                                                        <dx-validator>
                                                                            <dxi-validation-rule type="pattern"
                                                                                [pattern]="numberPattern"
                                                                                message="Only numbers are allowed">
                                                                            </dxi-validation-rule>
                                                                        </dx-validator>
                                                                    </dx-text-box>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="ml-3 leftfloat">
                                                                <div class="dx-field">
                                                                    <dx-check-box [readOnly]="productsReadOnly" class="topmargincb"
                                                                        [(value)]="ProductionData.bhyflag"
                                                                        text="BHy (MTD)">
                                                                    </dx-check-box>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="zeroPadding leftfloat">
                                                                <div class="dx-field">
                                                                    <dx-text-box [readOnly]="productsReadOnly"
                                                                        [(value)]="ProductionData.bhyKnm3h">
                                                                        <dx-validator>
                                                                            <dxi-validation-rule type="pattern"
                                                                                [pattern]="numberPattern"
                                                                                message="Only numbers are allowed">
                                                                            </dxi-validation-rule>
                                                                        </dx-validator>
                                                                    </dx-text-box>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr class="maxheight">
                                                        <td>
                                                            <div class="zeroPadding leftfloat">
                                                                <div class="dx-field">
                                                                    <dx-check-box [readOnly]="productsReadOnly" class="topmargincb"
                                                                        [(value)]="ProductionData.co2flag"
                                                                        text="(L) CO2 (MTD)">
                                                                    </dx-check-box>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="zeroPadding leftfloat">
                                                                <div class="dx-field">
                                                                    <dx-text-box [readOnly]="productsReadOnly"
                                                                        [(value)]="ProductionData.co2volumeTpd">
                                                                        <dx-validator>
                                                                            <dxi-validation-rule type="pattern"
                                                                                [pattern]="numberPattern"
                                                                                message="Only numbers are allowed">
                                                                            </dxi-validation-rule>
                                                                        </dx-validator>
                                                                    </dx-text-box>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td class="pl-3">Source Type :</td>
                                                        <td>
                                                            <dx-text-box [readOnly]="productsReadOnly"
                                                                #selectBox [(value)]="ProductionData.sourceOfGas"
                                                                [searchEnabled]="true">
                                                            </dx-text-box>
                                                        </td>
                                                    </tr>
                                                    <tr class="maxheight">
                                                        <td>
                                                            <div class="zeroPadding leftfloat">
                                                                <div class="dx-field">
                                                                    <dx-check-box class="topmargincb"
                                                                        [(value)]="ProductionData.argonPurifierFlag"
                                                                        text="Argon Purifier">
                                                                    </dx-check-box>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td></td>
                                                        <td>
                                                            <div class="ml-3 leftfloat">
                                                                <div class="dx-field">
                                                                    <dx-check-box class="topmargincb"
                                                                        [(value)]="ProductionData.lheFlag" text="LHe">
                                                                    </dx-check-box>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr class="maxheight">
                                                        <td>Liquifier Type :</td>
                                                        <td>
                                                            <dx-select-box style="width: 100%;" #selectBox
                                                                [dataSource]="liquifierTypeDataSource"
                                                                [acceptCustomValue]="false" displayExpr="liquifierType1"
                                                                valueExpr="typeLiquidId"
                                                                [(value)]="ProductionData.liquifierTypeId"
                                                                [searchEnabled]="true">
                                                            </dx-select-box>
                                                        </td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr *ngIf="ProductionData.liquifierTypeId == 'P'" class="maxheight">
                                                        <td>Host Customer :</td>
                                                        <td colspan="2">
                                                            <dx-text-box [(value)]="ProductionData.hostCustomer">
                                                            </dx-text-box>
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr *ngIf="SiteData.plantBusiness == 'T' || SiteData.plantBusiness == 'B'"
                                class="maxheight">
                                <td>Host Supplier</td>
                                <td>
                                    <div class="dx-field">
                                        <div class="dx-field-value">
                                            <dx-text-box [(value)]="ProductionData.hostSupplier"></dx-text-box>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr class="maxheight">
                                <td>SAP Plant ID</td>
                                <td>
                                    <div class="dx-field">
                                        <div class="dx-field-value">
                                            <dx-drop-down-box [(value)]="SAPgridBoxValue"
                                                [(opened)]="isSAPGridBoxOpened" valueExpr="sapplantId"
                                                [deferRendering]="false" [displayExpr]="gridBox_displayExpr"
                                                placeholder="Select a value..." [showClearButton]="true"
                                                [dataSource]="SAPgridDataSource"
                                                (onOptionChanged)="onSAPGridBoxOptionChanged($event)">
                                                <div *dxTemplate="let data of 'content'">
                                                    <dx-data-grid [dataSource]="SAPgridDataSource"
                                                        [hoverStateEnabled]="true" [(selectedRowKeys)]="SAPgridBoxValue"
                                                        height="100%">
                                                        <dxo-selection mode="single"></dxo-selection>
                                                        <dxo-filter-row [visible]="true"></dxo-filter-row>
                                                        <dxo-scrolling mode="virtual"></dxo-scrolling>
                                                        <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
                                                        <dxi-column dataField="sapplantId" caption="SAP Plant ID">
                                                        </dxi-column>
                                                        <dxi-column dataField="plantName"
                                                            caption="Plant Name"></dxi-column>
                                                    </dx-data-grid>
                                                </div>
                                            </dx-drop-down-box>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr *ngIf="SiteData.plantBusiness == 'M' || SiteData.plantBusiness == 'B'"
                                class="maxheight">
                                <td>Plant Status</td>
                                <td>
                                    <table>
                                        <tr class="maxheight">
                                            <td>
                                                <div class="dx-field">
                                                    <div class="dx-field-label">
                                                        <dx-check-box [(value)]="ProductionData.physicallyThereFlag"
                                                            text="Is physically there now?"></dx-check-box>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr class="maxheight">
                                            <td>
                                                <div class="dx-field">
                                                    <div class="dx-field-label">
                                                        <dx-check-box [(value)]="ProductionData.shutDownFlag"
                                                            text="Is not yet started up, is shutdown or is not running for any other reason.">
                                                        </dx-check-box>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr class="maxheight">
                                            <td>
                                                <div class="dx-field">
                                                    <div class="dx-field-label">
                                                        <dx-check-box [(value)]="ProductionData.dismantledFlag"
                                                            text="Is Dismantled?"></dx-check-box>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            <tr class="maxheight">
                                <td>Shutdown Date</td>
                                <td>
                                    <div class="dx-field">
                                        <div class="dx-field-value">
                                            <dx-date-box class="datefield" id="selected-date"
                                                [(value)]="ProductionData.shutdownDate">
                                            </dx-date-box>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr class="maxheight">
                                <td>Liquifier Type:</td>
                                <td>
                                    <div class="dx-field">
                                        <div class="dx-field-value">
                                            <dx-select-box style="width: 100%;" #selectBox
                                              [dataSource]="liquifierTypeDataSource"
                                              [acceptCustomValue]="false" displayExpr="liquifierType1"
                                              valueExpr="typeLiquidId"
                                              [(value)]="ProductionData.liquifierTypeId"
                                              [searchEnabled]="true">
                                          </dx-select-box>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr class="maxheight">
                                <td>Approx Onstream Date</td>
                                <td>
                                    <div class="dx-field">
                                        <div class="dx-field-value">
                                            <dx-date-box class="datefield" id="selected-date"
                                                [(value)]="ProductionData.onstreamDate">
                                            </dx-date-box>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr class="maxheight">
                                <td>Other</td>
                                <td>
                                    <div class="dx-field">
                                        <div class="dx-field-label">
                                            <dx-check-box [(value)]="ProductionData.nsf60certifiedFlag"
                                                (onValueChanged)="UpdateFlagValue($event,'nsf60certifiedFlag')"
                                                text="Plant is NSF60 certified."></dx-check-box>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>
                                    <div class="dx-field">
                                        <div class="dx-field-value">
                                            <dx-validation-summary></dx-validation-summary>
                                            <div class="red"
                                                *ngIf="!productsValidated">Put
                                                a check next to each gas produced at this site. At least one gas MUST be
                                                checked."</div>
                                                <div class="red" *ngIf="!companyOwnershipAdded"> Please add company ownership."</div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr class="maxheight">
                                <td colspan="2">
                                    <div>
                                        <div class="leftfloat">
                                            <dx-button [disabled]="!canAddEditRealPlant || !canAddEditProposedPlant" class="ap-green-btn mr-1 mt-1 ml-2 px-5" text="Save"
                                                (onClick)="setIsClose(false)" [useSubmitBehavior]="true"></dx-button>
                                        </div>
                                        <div class="leftfloat">
                                            <dx-button [disabled]="!canAddEditRealPlant || !canAddEditProposedPlant" class="ap-green-btn mr-1 mt-1 ml-2 px-5" text="Save Close"
                                                (onClick)="setIsClose(true)" [useSubmitBehavior]="true">
                                            </dx-button>
                                        </div>
                                        <div class="leftfloat">
                                            <dx-button class="ap-discard-button mr-1 mt-1 ml-2 px-5"
                                                text="Discard Close" (onClick)="OnDiscardCloseClicked()">
                                            </dx-button>
                                        </div>
                                        <div *ngIf="sharedSvc.UserRoles && (sharedSvc.UserRoles['isIGAdmin'] || sharedSvc.UserRoles['isTGEEAdmin'])"
                                            class="leftfloat">
                                            <dx-button class="ap-delete-button mr-1 mt-1 ml-2 px-5" text="Delete"
                                                (onClick)="OnDeleteClicked()">
                                            </dx-button>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </dx-validation-group>
    </form>
</div>
